import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { GroupVatPayload } from '../../../../../../utils/reducers/globals/groupVats'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import withLoading from '../../../../../../utils/hoc/withLoading'
import ModalCECostSell from './ModalCECostBuy'
import { CostSellModelType } from '@teinor/erp/types/company/config/cost/costSell'
import TwinTable from '../../../../../../baseComponents/TwinTable'
import BaseScreenTable from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { TableComponentProps } from '../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { CustomRenderString, EditRow, DeleteRow } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import ModalDeleteCostBuy from './ModalDeleteCostBuy'

interface ConfigCostBuysProps extends ComponentWithPermissions {}

const ConfigCostBuys: React.FC<ConfigCostBuysProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('costBuys', 'Costes de compra'),
        newText: t('newCost', 'Nuevo coste'),
    }

    return (
        <BaseScreenTable TableComponent={TableCostBuysConnect} CreateModalComponent={ModalCECostSell} EditModalComponent={ModalCECostSell} DeleteModalComponent={ModalDeleteCostBuy} pageData={pageData} userPermissions={userPermissions} />
    )
}

type TableCostBuysProps = TableComponentProps & ReduxConfigCostBuys & {}

const TableCostBuys: React.FC<TableCostBuysProps> = ({ userPermissions, setTableInstance, setOpened, groupVats }) => {
    const { t } = useTwinTranslation()

    const columns: ColumnTableSchema<CostSellModelType> = [
        {
            id: 'id',
            dataKey: 'id',
            label: t('id', 'ID'),
            sortable: true,
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'GroupVatId',
            dataKey: 'GroupVatId',
            label: t('groupVat', 'Grupo de impuestos'),
            customRender: (parameterValue) => <CustomRenderString value={String(groupVats?.[parameterValue]?.name || '')} />,
            generalSearchable: false
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'update')
        },
        {
            id: 'delete',
            dataKey: 'id',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable name='costBuys' columns={columns} getDataFrom='/api/app/config/cost/costBuy/getAllCostBuys' setTableInstance={setTableInstance} onRowClick={(_id, rowData) => setOpened({ type: 'edit', allRowData: rowData })} extraWhereParams={{active: true}} />
    )
}

const configCostBuysDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

export type ReduxConfigCostBuys = ConnectedProps<typeof configCostBuysConnect>
const mapConfigCostBuysConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const configCostBuysConnect = connect(mapConfigCostBuysConnector, configCostBuysDispatch)

const configCostBuysConnectLoading = withLoading(TableCostBuys, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])

const TableCostBuysConnect = configCostBuysConnect(configCostBuysConnectLoading)

export default ConfigCostBuys